import { call, put, takeEvery } from "redux-saga/effects";
import { getCataloguesError, getCataloguesSuccess } from "./actions";
import { GET_CATALOGUES } from "./actionType";
import { getGeneralCatalogue } from "../../resources/helper/catalogue";

function* getCatalogues({ payload: { catalogue } }) {
  try {
    const response = yield call(
      getGeneralCatalogue,
      catalogue.clientId,
      catalogue.type,
      catalogue.enable,
      catalogue.page,
      catalogue.limit,
    );
    yield put(getCataloguesSuccess(response));
  } catch (error) {
    yield put(getCataloguesError(error));
  }
}

function* CataloguesSaga() {
  yield takeEvery(GET_CATALOGUES, getCatalogues);
}

export default CataloguesSaga;
